@if (menuItems$ | async; as menuItems) {
  <div [class.dn-laptop-down]="!mobile" [class.dn-laptop-up]="mobile" data-elastic-exclude>
    @if (!mobile) {
      <nav [attr.aria-label]="activeMenuItemTitle$ | async">
        <ul class="no-list-style ps-large-bottom nordic-blue-900-text text-icon-primary">
          <ng-container *ngTemplateOutlet="itemList; context: { menuItems: menuItems }" />
        </ul>
      </nav>
    } @else {
      <fin-expand
        class="loyalty-nav-accordion relative block fill padding-left-gutter padding-right-gutter"
        [key]="'loyalty-section-nav'"
        [id]="'loyalty-section-mobile-nav'"
        #expandNav
      >
        <div class="trigger flex flex--center pr-xsmall-y" tabindex="-1">
          <div class="flex-1">
            <div
              class="flex flex--start nordic-blue-900-text text-icon-primary transform-none font-body-1 bold-type font-body-medium-bold"
            >
              {{ activeMenuItemTitle$ | async }}
            </div>
          </div>
          <fcom-icon
            class="flex-1 flex--nogrow rotate icon-small nordic-blue-900-text text-icon-primary"
            [class.rotate-active]="expandNav.isOpen$ | async"
            [name]="SvgLibraryIcon.CHEVRON_DOWN"
          />
        </div>
        <div class="content">
          <nav [attr.aria-label]="activeMenuItemTitle$ | async">
            <ul
              class="loyalty-nav-accordion-items no-list-style ps-large nordic-blue-900-text text-icon-primary grey-50-bg surface-disabled"
            >
              <ng-container *ngTemplateOutlet="itemList; context: { menuItems: menuItems }" />
            </ul>
          </nav>
        </div>
      </fin-expand>
    }
  </div>
}

<ng-template #itemList let-menuItems="menuItems">
  @for (item of menuItems; track $index) {
    <li>
      <a
        class="loyalty-nav-item ps-large-x mr-xxsmall-y no-decoration flex flex--middle nordic-blue-900-text text-icon-primary"
        [ngClass]="{
          'active bold-type link-hover': item.active,
        }"
        [finLink]="item.link"
        [external]="item.external"
        [attr.aria-current]="item.active ? 'page' : null"
        [attr.target]="item.openInNewTab ? '_blank' : ''"
        (click)="mobile ? toggleDetails(item.external) : null"
      >
        {{ item.teaserTitle }}
        @if (item.external) {
          <fcom-icon [name]="SvgLibraryIcon.EXTERNAL_TAB" class="icon-medium" />
        }
      </a>
    </li>
  }
</ng-template>
